<template>
    <a-row>
        <a-col :span="6">
            <img
                :src="imageSource"
                width="100%" height="auto"
            />
        </a-col>

        
        <a-col :span="16" class="details">
            <p>
                {{ productName }}
            </p>
            <p v-if="discount > 0.0">
                <s>{{ productPrice }}</s> / {{ getPrice() }} kr
            </p>
            <p v-else>
                {{ getPrice() }} kr
            </p>
            
        </a-col>
    </a-row>
</template>

<script>
import PriceCalculator from '../../commons/priceCalculator';
export default {
    name: 'ProductCardNotificationLine',
    props : {
        imageSource : { type: String },
        productName : { type: String },
        productPrice : { type : Number },
        discount : {type : Number, default : 0.0 },
        addedPrice : { type : Number, default : 0.0 }
    },
    methods : {
        getPrice() {
            return PriceCalculator.getProductPrice(this.productPrice, this.addedPrice, this.discount);
        }
    }
}
</script>
<style lang="scss">
.details{
margin-left: 10px;
}
</style>
